import {SelectorContainer} from './selector-container';
import {SectionsContainer} from './sections-container';
import {SuperObjectModel} from './super-object-model';
import {OperationDef} from './operation-def';
import {ContentInfo} from './content-info';
import {SearchContainer} from './search-container';

export class OperationContainer implements SelectorContainer {
  // Operation target is either 'object_view' or 'search_view'
  constructor(operationTarget: string) {
    this.operationTarget = operationTarget;
  }
  rootSectionsContainer: SectionsContainer;

  operationTarget: string;
  operationContextObjects: SuperObjectModel[];
  operationObjects: SuperObjectModel[];
  operations: OperationDef[] = [];
  currentOperation: OperationDef;
  currentSelectedGroupOperation: OperationDef;
  viewName: string;
  contentInfo: ContentInfo = new ContentInfo();
  inModal = false;
  enableSelector;
  disableSelector;
  selectorEnabled = false;

  art: SuperObjectModel;
  getTargetId;
  searchContainer: SearchContainer;
  selectorCallback;
  templateGroupId: string;
  listFieldTemplateId: string;
  openOperationDialogFn;
  refreshFn;

  get currentMenu() {
    return this.currentOperation;
  }

  cancelOperation() {
    console.warn('Cancel operation not implemented');
  }
}
